import dexie_db from "../../../../common/dexieDB";
import {
  getGrowthGraphZscore,
  getGrowthGraphPercentile,
} from "./growthGraphApiHandler";
import {
  GROWTH_CHART_PERCENTILE,
  GROWTH_CHART_ZSCORE,
} from "../../../ERXConstants/growthChartGraphConstants";

export const getGrowthGraph = async () => {
  let data = await getGrowthGraphDetailsIndexDB();

  if (!data) {
    let obj = {},
      obj1 = {};

    await Promise.all(
      Object.keys(GROWTH_CHART_PERCENTILE).map(async (key) => {
        obj[key] = await getGrowthGraphPercentile(GROWTH_CHART_PERCENTILE[key]);
      })
    );

    await Promise.all(
      Object.keys(GROWTH_CHART_ZSCORE).map(async (key) => {
        obj1[key] = await getGrowthGraphZscore(GROWTH_CHART_ZSCORE[key]);
      })
    );

    updateGrowthGraphDetailsIndexDB(obj, obj1);
  }
};

export const getGrowthGraphDetailsIndexDB = () => {
  return dexie_db.growthGraph
    .where("growthGraphDetails")
    .equals("growthGraphDetails")
    .toArray((data) => {
      return data.length > 0 ? data : null;
    });
};

export const updateGrowthGraphDetailsIndexDB = (percentileData, zscoreData) => {
  let dbData = { growthGraphDetails: "growthGraphDetails" };
  dbData["growth_graph_percentile"] = percentileData;
  dbData["growth_graph_zscore"] = zscoreData;
  dexie_db.growthGraph.put(dbData);
};
